import React from 'react';

export default function PageHero({ tag, title, subtitle, children }) {
  return (
    <section style={{
      background: 'var(--navy)',
      padding: '5rem 2rem 4rem',
      position: 'relative',
      overflow: 'hidden',
    }}>
      <div className="grid-overlay" style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: 4, background: 'linear-gradient(180deg, var(--orange), transparent)' }} />
      <div style={{ maxWidth: 1280, margin: '0 auto', position: 'relative', zIndex: 1 }}>
        {tag && (
          <span style={{
            fontFamily: '"Barlow Condensed"', fontSize: '0.8rem', fontWeight: 700,
            letterSpacing: '0.15em', textTransform: 'uppercase',
            color: 'var(--orange)', display: 'block', marginBottom: '0.5rem',
          }}>{tag}</span>
        )}
        <h1 style={{
          fontFamily: '"Bebas Neue"',
          fontSize: 'clamp(3rem, 6vw, 5rem)',
          color: 'white', letterSpacing: '0.03em', lineHeight: 1,
          marginBottom: subtitle ? '1rem' : 0,
        }}>{title}</h1>
        {subtitle && (
          <p style={{ fontSize: '1.1rem', color: 'var(--silver-light)', lineHeight: 1.6, maxWidth: 600 }}>{subtitle}</p>
        )}
        {children}
      </div>
    </section>
  );
}
